import React from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Stack, Typography } from "@mui/material";
import Cookies from 'universal-cookie';
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../themes/default";
import DatePickerIta from "./DatePickerMUI";
import getOrdine from "../services/getOrdine";
import moment from "moment";
import Loading from "react-loading";
import _ from 'lodash';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import editPosponiIngresso from "../services/editPosponiIngresso";
import deleteReminder from "../services/deleteReminder";
import getFattura from "../services/getFattura";
import editPosponiFattura from "../services/editPosponiFattura";

const cookies = new Cookies();
var token = cookies.get('token', { path: '/' });
var username = cookies.get('username', { path: '/' });

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'white',
    borderRadius: 2,
    border: '0',
    boxShadow: 24,
    p: 4,
};



export default class MyModalPosponi extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data:""
        }
    }


    async componentDidMount() {
        this.setState({ loading: true });
        let data = moment(this.props.modal.data_scadenza, 'DD-MM-YYYY').format('DD/MM/YYYY');
        this.setState({ data, loading: false });
    }

    async updatePagamenti() {
        if (this.props.modal.tipo === 'commessa_in') {
            let res = await getOrdine(username, token, this.props.modal.id)
            if (res) {
                let pagamenti = JSON.parse(res.pagamento);
                var i = 0;
                for (const pagamento of pagamenti) {
                    var temp = _.cloneDeep(pagamento.from === 'DO' ? res.data_creazione.split(' ')[0].split('-').reverse().join('/') : pagamento.from === 'DC' ? res.data_consegna : res.data_pronto);
                    let data = moment(temp, 'DD/MM/YYYY').add(pagamento.days, 'days').format('DD/MM/YYYY');
                    if (data === this.props.modal.data_scadenza) {
                        let diffDays = moment(this.state.data, 'DD/MM/YYYY').diff(moment(this.props.modal.data_scadenza, 'DD/MM/YYYY'), 'days');
                        pagamenti[i]['days'] = diffDays.toString();
                        break;
                    }
                    
                    i++;
                };
                let update = await editPosponiIngresso(username, token, this.props.modal.id, JSON.stringify(pagamenti));
                if (update.result === 'ok') {
                    deleteReminder(username, token, this.props.modal.idReminder);
                    this.props.onReload();
                    this.props.onClose();
                }
            }
        } else {
            getFattura(username, token, this.props.modal.id).then((res) => {
                let data_disposizione = JSON.parse(res.date_disposizioni);
                let disposizioni = JSON.parse(res.disposizioni);
                var i = 0;
                for (const singleDataDisposizione of data_disposizione) {
                    let data = moment(this.state.data, 'DD/MM/YYYY').format('DD/MM/YYYY');
                    data_disposizione[i]['data'] = data;

                    let object = {
                        value :'1000',
                        label: 'personalizza'
                    }
                    disposizioni[i] = object;
                    
                    i++;
                };
                
                editPosponiFattura(username, token, this.props.modal.id, JSON.stringify(data_disposizione), JSON.stringify(disposizioni)).then((res) => {
                    if (res.result === 'ok') {
                        deleteReminder(username, token, this.props.modal.idReminder);
                        this.props.onReload();
                        this.props.onClose();
                    }
                })
            })
        }
    }

    close() {
        this.props.onClose();
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }
        return (
            <Modal
                disableEnforceFocus
                open={this.props.modal.show}
                onClose={() => this.props.onClose()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction='column' spacing={4} sx={{ flex: 1, mb: 3, }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Posponi
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            closeOnSelect
                            defaultValue={moment(this.state.data, 'DD/MM/YYYY')}
                            label="Data Pagamento"
                            onChange={(e) => {
                                this.setState({ data: e});
                            }}
                        />
                    </LocalizationProvider>
                    </Stack>
                    <LoadingButton loading={this.state.loading} variant="contained" onClick={() => {if(window.confirm(this.props.modal.tipo === 'commessa_in' ? "Sei sicuro di voler posporre il pagamento?" : "Sei sicuro di voler posporre la fattura?")) {this.updatePagamenti()}}} sx={{ height: 50, width: 300, }} >Posponi</LoadingButton>
                </Box>
            </Modal>
        )
    }
}